import type { Workspace } from "@/supabase.types";
import { getDateDaysDifferenceToNow } from "@/utils/dates";
import { getFromLocalStorage, setToLocalStorage } from "@/utils/localStorageCache";

const CACHED_WORKSPACE_KEY = "RECENT_WORKSPACE";

export const getCachedWorkspace = (): string | undefined | null => {
  const workspace_id = getFromLocalStorage(CACHED_WORKSPACE_KEY);
  if (workspace_id) return workspace_id;
};

export const setCachedWorkspace = (workspace_id?: string): void => {
  if (!workspace_id) return;
  setToLocalStorage(CACHED_WORKSPACE_KEY, workspace_id);
};

export const getIdealWorkspace = (workspaces: Workspace[]): Workspace => {
  // check localStorage for recent cached workspace
  const cachedWorkspaceId = getCachedWorkspace();
  const cachedWorkspace = workspaces.find((workspace) => workspace.id === cachedWorkspaceId);
  if (cachedWorkspace) return cachedWorkspace;

  // get nextbest workspace that have no trial or still valid trial
  const eligibleWorkspaces = workspaces.filter((workspace) => {
    if (!workspace.trial_end_date) return true;
    const daysLeft = Math.max(0, getDateDaysDifferenceToNow(workspace.trial_end_date));
    if (daysLeft > 0) return true;
    return false;
  });

  if (eligibleWorkspaces.length > 0) return eligibleWorkspaces[0];

  // get nextbest workspace (we assume there is atleast one)
  return workspaces[0];
};

const DEFAULT_WORKSPACE_NAME = "ABC";
export const generateWorkspaceAbbreviation = (workspaceName: string = DEFAULT_WORKSPACE_NAME): string => {
  // Start with uppercase letters from the name (remove special chars, extra spaces, etc.)
  const cleanedText = workspaceName.toUpperCase().replace(/[^A-Z]/g, "");

  // If no letters remain, use a default base
  if (cleanedText === "") {
    return DEFAULT_WORKSPACE_NAME;
  }

  // Pad with 'X' if too short
  if (cleanedText.length < 3) {
    return cleanedText.padStart(3, "X");
  }

  return cleanedText.slice(0, 3);
};
